import IconButton from '@mui/material/IconButton';
import { useState } from 'react';
import {
  AllPossibleActions,
  ChartAction,
  useChartActions,
} from './hooks/useChartActions';

type Props = {
  onAction: (actionId: AllPossibleActions) => void;
};
export const ChartActions = ({ onAction }: Props) => {
  const actions = useChartActions();

  const handleActionItemClick = (
    actionId: AllPossibleActions,
    chartActionCallback: ChartAction['onClick']
  ) => {
    onAction?.(actionId);
    chartActionCallback?.();
  };

  return (
    <>
      {actions.map((action) => (
        <ChartActionItem
          key={action.actionId}
          onClick={() => handleActionItemClick(action.actionId, action.onClick)}
          action={action}
        />
      ))}
    </>
  );
};

type ChartActionItemProps = {
  onClick: () => void;
  action: ChartAction;
};
const ChartActionItem = ({ action, onClick }: ChartActionItemProps) => {
  const { Icon, ActionDialog } = action;
  const [displayActionDialog, setDisplayActionDialog] =
    useState<boolean>(false);

  const handleIconButtonClick = () => {
    onClick();

    if (ActionDialog) {
      setDisplayActionDialog(true);
    }
  };

  return (
    <>
      <IconButton
        onClick={handleIconButtonClick}
        sx={{
          mr: 1,
        }}
      >
        <Icon
          sx={{
            fill: (theme) => theme.colors.common.white,
          }}
        />
      </IconButton>
      {ActionDialog && (
        <ActionDialog
          open={displayActionDialog}
          onClose={() => setDisplayActionDialog(false)}
        />
      )}
    </>
  );
};
